<template>
  <Modal
    class="review-yandex-modal"
    icon="like"
    :title="$t('modals.reviewYandex.title')"
    @close="$emit('close')"
  >
    <template #text>
      <div class="review-yandex-modal__text">{{ $t('modals.reviewYandex.text') }}</div>
    </template>
    <template #footer>
      <a :href="REVIEW_LINK" target="_blank" rel="noopener">
        <Button>
          {{ $t('modals.reviewYandex.submit') }}
        </Button>
      </a>
    </template>
  </Modal>
</template>

<script>
import './review-yandex-modal.scss'
import Modal from '@/components/Base/Modal/modal.vue'
import Button from '@/components/Base/Button/Button.vue'

// Карточка сайта в Яндексе — там же живут отзывы о нём. Адрес тот же, что у
// Дерева в списке сервисов отзывов (src/entities/reviews/model/const.ts),
// только со своим доменом.
//
// У Дерева модалка состоит из одной гифки-инструкции без ссылки: 312 КБ на
// десктоп и 1,3 МБ на мобилку, и обе показывают процесс для rbxtree.io — нам
// они не годятся, нужны свои. Пока их нет, ведём ссылкой: так модалка приносит
// пользу сразу, а инструкцию можно добавить рядом, когда придёт дизайн.
const REVIEW_LINK = 'https://webmaster.yandex.ru/siteinfo/?site=rbxpier.me'

export default {
  name: 'ReviewYandexModal',
  components: {
    Button,
    Modal
  },
  data() {
    return { REVIEW_LINK }
  }
}
</script>
